/**
 * SideBarHeading.js
 * Styled Component for placing the Heading in the sidebar
 */
import styled from "styled-components";

// Styles
const SideBarHeading = styled.div`
    display: flex;
    place-content: space-between;
    align-items: center;
    cursor: pointer;
`;

export default SideBarHeading;